import { render, staticRenderFns } from "./checkStrictly-editor.vue?vue&type=template&id=7e3d1d4c&scoped=true&"
import script from "./checkStrictly-editor.vue?vue&type=script&lang=js&"
export * from "./checkStrictly-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3d1d4c",
  null
  
)

export default component.exports